import React from "react";
import { cn } from "../../lib/utils";

export function Progress({ value = 0, className, indicatorClassName }) {
  const v = Math.max(0, Math.min(100, value));
  return (
    <div className={cn("h-1.5 w-full bg-secondary overflow-hidden rounded-sm", className)}>
      <div
        className={cn("h-full bg-accent transition-all", indicatorClassName)}
        style={{ width: `${v}%` }}
      />
    </div>
  );
}
